import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';
import {
  showMiniCart,
  closeMiniCart,
  toggle,
  setMiniCartVisible,
  update,
} from '../Actions/Cart.action';

const MiniCartContainer = (props) => {
  return <MiniCart {...props} />;
};

const mapStateToProps = (state) => {
  const { cart } = state;
  return {
    ...cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggle: () => dispatch(toggle()),
    closeMiniCart: () => dispatch(closeMiniCart()),
    showMiniCart: () => dispatch(showMiniCart()),
    onClosed: () => dispatch(setMiniCartVisible(false)),
    updateRow: (articleNumber, quantity, rowSystemId) =>
      dispatch(update(articleNumber, quantity, rowSystemId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer);
